export enum OrganizationPerspective {
    UserPerspective = 0,
    EMRPerspective = 1,
    InfoPerspective = 2
}
